module.exports = __webpack_public_path__ + "img/box3_img2_light.e3faf260.png";